import { Component, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Field } from '../../models/field';
import { FieldConfig } from '../../models/field-config';

@Component({
  selector: 'form-spinner',
  styleUrls: ['./form-spinner.component.scss'],
  template:`
  <div class="dynamic-field form-input col-12" [formGroup]="group">
    <div class="row" style="margin-bottom: 5px;">
      <div class="col-3">
        <label>{{ config.name }} <span *ngIf="config.validation" style="color: red"> *</span></label>
      </div>
      <div class="col-9" >
        <p-spinner [style]="{'width':'100%'}" [attr.placeholder]="config.placeholder"  [min]="0" [formControlName]="config.name"></p-spinner>
      </div>
    </div>
  </div>
    `,
})
export class FormSpinnerComponent implements Field {
  config: FieldConfig;
  group: FormGroup;


}
